import React, { useEffect, useState } from "react";
import Appbar from "./Appbar";
import Sidebar from "./Sidebar";
import {
  Button,
  CircularProgress,
  Grid,
  OutlinedInput,
  Paper,
} from "@mui/material";
import "../Assets/CSS/BnbConnect.css";
import { useLocation, useNavigate } from "react-router-dom";
import Web3 from "web3";
import Swal from "sweetalert2";

// ✅ MULTI RPC (mobile safe)
const RPCS = [
  "https://bsc-dataseed.binance.org",
  "https://rpc.ankr.com/bsc",
  "https://bsc.publicnode.com",
  "https://bsc.meowrpc.com"
];

// ✅ PROVIDER DETECTION
const getProvider = () => {
  if (window.ethereum) return window.ethereum;
  return null;
};

const SellToken = () => {
  const tokenABI = [
    {
      inputs: [
        { internalType: "address", name: "_a1", type: "address" },
        { internalType: "address", name: "_a2", type: "address" },
        { internalType: "address", name: "_a3", type: "address" },
        { internalType: "address", name: "_a4", type: "address" },
        { internalType: "address", name: "_a5", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokens",
          type: "uint256",
        },
      ],
      name: "Buy",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "claimId",
          type: "uint256",
        },
      ],
      name: "LevelIncomeClaimed",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
      ],
      name: "LevelReward",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokens",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
      ],
      name: "Sell",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [],
      name: "AwardFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "BuyBNBConnect",
      outputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [],
      name: "ExpenseFund",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "ExpenseWallet",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "GetExpense",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "GetRoyalty",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "ITFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "LC",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "LP",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "LegalFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "LevelCountribution",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "LevelFund",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "LevelIncomeWallet",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "LevelMemberCount",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "Liqudity",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "MarketingFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "OnOffBuy",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "RoyaltyB",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "RoyaltyWalletC",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "_owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "addressToUserId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "bcc_Price",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "buyId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "buyRecord",
      outputs: [
        { internalType: "address", name: "cust_address", type: "address" },
        { internalType: "uint256", name: "bnb_amt", type: "uint256" },
        { internalType: "uint256", name: "bbcPrice", type: "uint256" },
        { internalType: "uint256", name: "token_to_user", type: "uint256" },
        { internalType: "uint256", name: "distribution_amt", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "claimLevelIncome",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "customerId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "distribute_level",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "getUserBuyRecords",
      outputs: [
        {
          components: [
            { internalType: "address", name: "cust_address", type: "address" },
            { internalType: "uint256", name: "bnb_amt", type: "uint256" },
            { internalType: "uint256", name: "bbcPrice", type: "uint256" },
            { internalType: "uint256", name: "token_to_user", type: "uint256" },
            {
              internalType: "uint256",
              name: "distribution_amt",
              type: "uint256",
            },
          ],
          internalType: "struct BnbConnectToken.Buyhistory[]",
          name: "",
          type: "tuple[]",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "getUserSellCount",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "user", type: "address" },
        { internalType: "uint256", name: "index", type: "uint256" },
      ],
      name: "getUserSellDetails",
      outputs: [
        { internalType: "uint256", name: "token", type: "uint256" },
        { internalType: "uint256", name: "bnbAmount", type: "uint256" },
        { internalType: "uint256", name: "adminFee", type: "uint256" },
        { internalType: "uint256", name: "finalAmount", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "isBuyPause",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "isRegistered",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "levelClaimId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "levelClaimRecord",
      outputs: [
        { internalType: "address", name: "user", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
        { internalType: "uint256", name: "time", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "payoutPercent",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "refer_address", type: "address" },
      ],
      name: "register",
      outputs: [{ internalType: "uint256", name: "custid", type: "uint256" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenAmount", type: "uint256" },
      ],
      name: "sellBCC",
      outputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "sellId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "sellRecord",
      outputs: [
        { internalType: "address", name: "cust_address", type: "address" },
        { internalType: "uint256", name: "token", type: "uint256" },
        { internalType: "uint256", name: "bnb_amt", type: "uint256" },
        { internalType: "uint256", name: "admin_amt", type: "uint256" },
        { internalType: "uint256", name: "final_amt", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalCollection",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "totalLevelIncome",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalMint",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "recipient", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "sender", type: "address" },
        { internalType: "address", name: "recipient", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "userLevelClaimIds",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "userRegister",
      outputs: [
        { internalType: "address", name: "customer_address", type: "address" },
        { internalType: "address", name: "referral_address", type: "address" },
        { internalType: "uint256", name: "totalDeposit", type: "uint256" },
        { internalType: "uint256", name: "totalSellBnb", type: "uint256" },
        { internalType: "uint256", name: "level_income", type: "uint256" },
        { internalType: "uint256", name: "totalbnbcSell", type: "uint256" },
        { internalType: "uint256", name: "directCount", type: "uint256" },
        { internalType: "uint256", name: "directBusiness", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "userSellIds",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
  ];
  const location = useLocation();
  const navigate = useNavigate();

  const walletAddress =
    location.state?.wallet || localStorage.getItem("walletAddress");

  const tokenAddress = "0x7c96F64a8427dE1F68eceb221E79d4DD2E8d0744";



  const [mobileOpen, setMobileOpen] = useState(false);
  const [token, setToken] = useState(0);
  const [bccprice, setBccPrice] = useState(0);
  const [sellAmount, setSellAmount] = useState("");
  const [bnbAmount, setBnbAmount] = useState("0");
  const [loading, setLoading] = useState(false);
  const [web3Instance, setWeb3Instance] = useState(null);
  const [userData, setUserData] = useState(null);
  const [userId, setUserId] = useState("");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // ✅ GET WORKING RPC
  const getWeb3RPC = async () => {
    for (let rpc of RPCS) {
      try {
        const web3 = new Web3(new Web3.providers.HttpProvider(rpc));
        await web3.eth.getBlockNumber();
        return web3;
      } catch (e) {
        continue;
      }
    }
    throw new Error("All RPCs failed");
  };

  // ✅ FETCH DATA (RPC ONLY)
  const getUserData = async () => {
    try {
      const wallet =
        walletAddress || localStorage.getItem("walletAddress");

      if (!wallet) {
        console.log("Wallet missing");
        return;
      }

      // ✅ ALWAYS USE RPC (NO provider)
      const web3 = await getWeb3RPC();

      const contract = new web3.eth.Contract(tokenABI, tokenAddress);

      const balance = await contract.methods.balanceOf(wallet).call();
      const price = await contract.methods.bcc_Price().call();

      // console.log("BALANCE:", balance);

      setToken(balance);
      setBccPrice(price);
      setWeb3Instance(web3);

    } catch (error) {
      console.error("SAFE ERROR:", error);

      // ❌ Swal remove temporarily
    }
  };

  // ✅ CALCULATE AMOUNT
  const handleAmountChange = (e) => {
    const value = e.target.value;
    setSellAmount(value);

    if (!value || !bccprice || !web3Instance) {
      setBnbAmount("0");
      return;
    }

    try {
      const tokenBalance = parseFloat(
        web3Instance.utils.fromWei(token.toString(), "ether"),
      );

      if (parseFloat(value) > tokenBalance) {
        Swal.fire("Error!", "Insufficient Balance", "error");
        return;
      }

      const price = parseFloat(
        web3Instance.utils.fromWei(bccprice.toString(), "ether"),
      );

      const result = parseFloat(value) * price;
      setBnbAmount(result.toFixed(6));
    } catch {
      setBnbAmount("0");
    }
  };


 const handleSubmit = async () => {
  try {
    setLoading(true);

    const provider = getProvider();
    if (!provider) throw new Error("Wallet not found");

    const accounts = await provider.request({
      method: "eth_requestAccounts",
    });

    const user = accounts[0];
    const web3 = new Web3(provider);
    const contract = new web3.eth.Contract(tokenABI, tokenAddress);

    if (!sellAmount || Number(sellAmount) <= 0) {
      throw new Error("Enter valid amount");
    }

    const amountInWei = web3.utils.toWei(
      sellAmount.toString(),
      "ether"
    );

    let gasLimit;

    try {
      gasLimit = await contract.methods
        .sellBCC(amountInWei)
        .estimateGas({ from: user });
    } catch (e) {
      gasLimit = 300000;
    }

    await contract.methods.sellBCC(amountInWei).send({
      from: user,
      gas: gasLimit,
    });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Token Sold Successfully!",
      confirmButtonText: "OK",
    }).then(() => {
      window.location.reload();
    });

  } catch (error) {
    console.error(error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Transaction failed",
      confirmButtonText: "OK",
    }).then(() => {
      window.location.reload();
    });

  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const storedWallet = localStorage.getItem("walletAddress");

    if (storedWallet) {
      getUserData();
    } else {
      console.log("No wallet found on refresh");
    }
  }, []);

  const convertWeiToEther = (value) => {
    if (!web3Instance || !value) return "0";
    return web3Instance.utils.fromWei(value.toString(), "ether");
  };


  return (
    <div className="bnbcontainer">
      <Grid container>
        <Grid item xs={12}>
          <Appbar handleDrawerToggle={handleDrawerToggle} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item md={2}>
              <Sidebar
                open={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
                userId={userId}
                setUserId={setUserId}
                userData={userData}
                setUserData={setUserData}
                walletAddress={walletAddress}
              />
            </Grid>

            <Grid item xs={12} md={10} sx={{ mt: "70px" }}>
              <Grid container spacing={3} p={3}>
                <Grid item xs={12} md={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      backgroundColor: "#232529",
                      color: "white",
                      padding: "15px",
                      borderRadius: "10px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <div className="headerconn">
                          <div
                            className="dashbheading"
                            onClick={() => {
                              navigate("/dashboard");
                            }}
                          >
                            Dashboard
                          </div>
                          <div className="subheading">/ Sell Token</div>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper
                    elevation={3}
                    sx={{
                      backgroundColor: "#232529",
                      color: "white",
                      borderRadius: "20px",
                    }}
                  >
                    <Grid container spacing={2} p={3}>
                      <Grid item xs={12}>
                        <div className="topuptitle">Sell Token</div>
                      </Grid>

                      <Grid item xs={12}>
                        <OutlinedInput
                          value={convertWeiToEther(token)}
                          className="whiteInput"
                          fullWidth
                          readOnly
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <OutlinedInput
                          value={convertWeiToEther(bccprice)}
                          className="whiteInput"
                          fullWidth
                          readOnly
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <OutlinedInput
                          placeholder="Enter Amount"
                          value={sellAmount}
                          onChange={handleAmountChange}
                          fullWidth
                          className="whiteInput"
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <div>You Will Get: {bnbAmount} BNB</div>
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleSubmit}
                          sx={{ width: "Auto" }}
                        >
                          {loading ? (
                            <CircularProgress
                              size={24}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SellToken;
